import {
  Box,
  Button,
  Heading,
  Input,
  Text
} from '@chakra-ui/react'
import { GameCredentials } from '@olagg/db-types'
import { ICompletedFields } from '..'
import { IMultiStageModalContent } from '../../../interfaces/IMultiStageModalContent'
import { titleCase } from '../utils'

interface IProps {
  credentials: GameCredentials
  fieldsToComplete: string[]
  completedFields: ICompletedFields
  setCompletedFields: (value: ICompletedFields) => void
  onClickContinue: () => void
}

export const RequestInfo = ({
  credentials,
  fieldsToComplete,
  completedFields,
  setCompletedFields,
  onClickContinue
}: IProps): IMultiStageModalContent => {
  return {
    body: (
      <>
        <Heading
          fontSize={'24px'}
          color={'olaggPurple.100'}
          pb={4}
        >
          ¡Ya estamos próximos!
        </Heading>
        <Text
          fontSize={'16px'}
          lineHeight={'24px'}
          fontFamily={'text'}
        >
          Completa el siguiente formulario para habilitar tu
          beca:
        </Text>
        {fieldsToComplete.map((field, i) => {
          if (field === 'username')
            return (
              <Input
                key={i}
                mt={3}
                variant="flushed"
                placeholder="Ingresar Nombre de Usuario"
                value={completedFields.username}
                onChange={e =>
                  setCompletedFields({
                    ...completedFields,
                    username: e.target.value
                  })
                }
              />
            )
          if (field === 'email')
            return (
              <Input
                key={i}
                mt={3}
                variant="flushed"
                placeholder="Ingresar Email"
                value={completedFields.email}
                onChange={e =>
                  setCompletedFields({
                    ...completedFields,
                    email: e.target.value
                  })
                }
              />
            )
          if (field === 'password')
            return (
              <Input
                key={i}
                mt={3}
                variant="flushed"
                placeholder="Ingresar Contraseña"
                value={completedFields.password}
                onChange={e =>
                  setCompletedFields({
                    ...completedFields,
                    password: e.target.value
                  })
                }
              />
            )
          if (field === 'walletAddress')
            return (
              <Input
                key={i}
                mt={3}
                variant="flushed"
                placeholder={`Ingresar Wallet Address ${titleCase(
                  credentials.blockchain[0]
                )}`}
                value={completedFields.walletAddress}
                onChange={e =>
                  setCompletedFields({
                    ...completedFields,
                    walletAddress: e.target.value
                  })
                }
              />
            )
          if (field === 'seedPhrase')
            return (
              <Input
                key={i}
                mt={3}
                variant="flushed"
                placeholder="Ingresar Seed Phrase"
                value={completedFields.seedPhrase}
                onChange={e =>
                  setCompletedFields({
                    ...completedFields,
                    seedPhrase: e.target.value
                  })
                }
              />
            )
          if (field === 'nftIdentifier')
            return (
              <Input
                key={i}
                mt={3}
                variant="flushed"
                placeholder="Ingresar Identificador NFT"
                value={completedFields.nftIdentifier}
                onChange={e =>
                  setCompletedFields({
                    ...completedFields,
                    nftIdentifier: e.target.value
                  })
                }
              />
            )
          if (field === 'userNotes')
            return (
              <Input
                key={i}
                mt={3}
                variant="flushed"
                placeholder="Ingresar Notas"
                value={completedFields.userNotes}
                onChange={e =>
                  setCompletedFields({
                    ...completedFields,
                    userNotes: e.target.value
                  })
                }
              />
            )
        })}
      </>
    ),
    footer: (
      <Box px={1} w={'full'}>
        <Button
          variant={'filledGradient'}
          w={'full'}
          onClick={onClickContinue}
        >
          Continuar
        </Button>
      </Box>
    )
  }
}
